//#region stateSection
import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";
import { IoArrowBackSharp } from "react-icons/io5";
import { MdOutlineAddCircleOutline } from "react-icons/md";
import { TbTrash, TbTrashOff } from "react-icons/tb";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import Select from "react-select";
import { Button, Col, FormGroup, Input, Label, Row } from "reactstrap";
import { ToastContainer } from "react-toastify";
import swal from "sweetalert";
import {
  CheckPermission,
  LoadingSpinner,
  convertToDateString,
  customOption,
  customSingleValue,
  isUrdu,
} from "../../constants/const";
import { encryptStorage } from "../../constants/EncryptStorage";
import SearchAutoComplete from "../shared/SearchAutoComplete";
import { ApiFund } from "./ApiFund";
import { addMember } from "../member/ApiMember";
import { GetLanguageString } from "../helper/Components";
import { GetCustomStyles, GetSelectedLanguage, isUsraRole } from "../helper/Method";
import SelectUnit from "../shared/SelectUnit";
import { ApiFinance } from "./ApiFinance";
import { getMinMaxDates, validateTransactionDate } from "./fiscalYearHelper";
import { viewReceiptPdf } from "../shared/receiptViewer";
import MemberAddressPreview from "./MemberAddressPreview";
//#endregion stateSection
const AddInfaqAmanatAccount = ({ history }) => {
  //#region stateDeclare
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const [serverError, setServerError] = useState("");
  const loggedInUnitId = parseInt(encryptStorage.getItem("loggedInUnitId"));
  const [members, setMembers] = useState([]);
  const [selectedMember, setSelectedMember] = useState(null);
  const [recipientType, setRecipientType] = useState("rafiq"); // 'rafiq' | 'rafiq_outside' | 'registered' | 'unregistered'
  const [ahbabOptions, setAhbabOptions] = useState([]);
  const [selectedHabib, setSelectedHabib] = useState(null);
  const [outsideRafiqOptions, setOutsideRafiqOptions] = useState([]);
  const [selectedOutsideRafiq, setSelectedOutsideRafiq] = useState("");
  const [loadingSearchOutside, setLoadingSearchOutside] = useState(false);
  const [unregisteredHabibName, setUnregisteredHabibName] = useState("");
  const [values, setValues] = useState({
    unit: { value: loggedInUnitId, lable: "" },
    includeSubUnit: false,
  });
  const unitId = values.unit.value;
  const [errors, setErrors] = useState({ selectedMember: "" });
  const fieldColSize = 3; // uniform column size for form fields
  let membersList = [];
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [fundValues, setFundValues] = useState({});
  const [infaqHeads, setInfaqHeads] = useState([]);
  const [selectedInfaqHead, setSelectedInfaqHead] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [memberId, setMemberId] = useState(0);
  const [receiptType, setReceiptType] = useState(isUsraRole() ? "digital" : "physical");
  const [address, setAddress] = useState("");

  // Dynamic rows state
  const [infaqRows, setInfaqRows] = useState([{ codeId: "", amount: "" }]);

  const addRow = () => {
    const defaultCodeId = infaqHeads.length > 0 ? infaqHeads[0].value : "";
    setInfaqRows([...infaqRows, { codeId: defaultCodeId, amount: "" }]);
  };

  const removeRow = (index) => {
    if (infaqRows.length > 1) {
      setInfaqRows(infaqRows.filter((_, i) => i !== index));
    }
  };

  const handleRowChange = (index, field, val) => {
    const newRows = [...infaqRows];
    newRows[index][field] = val;
    setInfaqRows(newRows);

    if (errors.rowErrors && errors.rowErrors[index]) {
      const newErrors = { ...errors };
      newErrors.rowErrors[index][field] = "";
      setErrors(newErrors);
    }
  };

  const viewReceipt = (transactionNo) =>
    viewReceiptPdf({
      transactionNo,
      type: "infaq",
      t,
      onSuccess: () => setTimeout(() => history.goBack(), 4000),
    }).catch(() => false);
  // //#region useEffectSection
  useEffect(() => {
    let currentDate = new Date();
    let tempYear = currentDate.getFullYear();
    let tempMonth = currentDate.getMonth() + 1;
    setFundValues({
      memberId:
        recipientType === "rafiq"
          ? selectedMember?.value || null
          : (recipientType === "registered" || recipientType === "rafiq_outside")
            ? memberId || null
            : null,
      name:
        recipientType === "rafiq"
          ? selectedMember?.label || ""
          : recipientType === "rafiq_outside"
            ? selectedOutsideRafiq || ""
            : recipientType === "registered"
              ? selectedHabib || ""
              : unregisteredHabibName || "",
      includeSubUnit: values.includeSubUnit || false,
      unitId: unitId,
      date: currentDate,
      month: tempMonth,
      year: tempYear,
      receiptNumber: "",
      amount: null,
      memo: "",
      codeId: selectedInfaqHead?.value,
    });
  }, [
    unitId,
    selectedMember,
    selectedInfaqHead,
    recipientType,
    selectedHabib,
    selectedOutsideRafiq,
    unregisteredHabibName,
    values.includeSubUnit,
    memberId,
  ]);
  useEffect(() => {
    setLoading(true);
    ApiFinance()
      .GetFinanceSubCategoryAccountsByCode("infaq")
      .then((res) => {
        if (res?.data) {
          setInfaqHeads(res.data); // default select first one
          if (res.data.length > 0) {
            setSelectedInfaqHead(res.data[0]);
            setInfaqRows([{ codeId: res.data[0].value, amount: "" }]);
            setFundValues((prev) => ({ ...prev, codeId: res.data[0].value }));
          }
          setLoading(false);
        }
      })
      .catch((err) => {
        swal({ title: err, icon: "error", buttons: "OK" });
        console.error(err);
      });
  }, []);
  useEffect(() => {
    addMember()
      .getUnitMembersForSelecting(values.unit.value, values.includeSubUnit)
      .then((res) => {
        setMembers(res.data);
        if (res.data.length !== 0) {
          setSelectedMember({
            value: res.data[0].id,
            label: res.data[0].name + " - " + res.data[0].regNo,
            name: res.data[0].name,
            regNo: res.data[0].regNo,
          });
          setErrors((prev) => ({ ...prev, selectedMember: "" }));
        } else {
          setSelectedMember({});
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, [values.unit.value, values.includeSubUnit]);

  useEffect(() => {
    if (selectedHabib && !selectedHabib.includes("/")) {
      setLoadingSearch(true);

      const timeoutId = setTimeout(() => {
        addMember()
          .getUnitParticipantsByType(
            values.unit.value,
            values.includeSubUnit,
            "habib",
            selectedHabib,
          )
          .then((res) => {
            if (res.data) {
              setAhbabOptions(res.data);
            }
            setLoadingSearch(false);
          })
          .catch((err) => {
            swal({ title: err, icon: "error", buttons: "OK" });
            console.error(err);
            setLoadingSearch(false);
          });
      }, 1000);

      return () => clearTimeout(timeoutId);
    }
  }, [selectedHabib, values.unit.value, values.includeSubUnit]);

  useEffect(() => {
    if (selectedOutsideRafiq && !selectedOutsideRafiq.includes("/")) {
      setLoadingSearchOutside(true);

      const timeoutId = setTimeout(() => {
        addMember()
          .getParentHierarchyParticipantsByType(
            values.unit.value,
            "rafiq",
            selectedOutsideRafiq,
          )
          .then((res) => {
            if (res.data) {
              setOutsideRafiqOptions(res.data);
            }
            setLoadingSearchOutside(false);
          })
          .catch((err) => {
            swal({ title: err, icon: "error", buttons: "OK" });
            console.error(err);
            setLoadingSearchOutside(false);
          });
      }, 1000);

      return () => clearTimeout(timeoutId);
    }
  }, [selectedOutsideRafiq, values.unit.value]);
  //#endregion useEffectSection

  //#region functionHandler
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const maxSize = 1 * 1024 * 1024; // 1MB

    if (file.size > maxSize) {
      setErrors((prev) => ({ ...prev, file: "File must be under 1MB" }));
      setUploadedFile(null);
    } else {
      setErrors((prev) => ({ ...prev, file: "" }));
      setUploadedFile(file);
    }
  };

  if (members.length !== 0) {
    members.forEach((m) =>
      membersList.push({
        value: m.id,
        label: m.name + " - " + m.regNo,
        name: m.name,
        regNo: m.regNo,
      }),
    );
  }
  const validate = () => {
    let temp = {};
    temp.month = fundValues.month ? (
      ""
    ) : (
      <GetLanguageString props="common_field_required_error" />
    );
    temp.year = fundValues.year ? (
      ""
    ) : (
      <GetLanguageString props="common_field_required_error" />
    );
    temp.receiptNumber =
      receiptType === "physical" ? (
        fundValues.receiptNumber ? (
          ""
        ) : (
          <GetLanguageString props="common_field_required_error" />
        )
      ) : (
        ""
      );
    const dateError = validateTransactionDate(selectedDate);
    if (dateError) {
      temp.date = t(dateError);
    } else {
      temp.date = selectedDate ? (
        ""
      ) : (
        <GetLanguageString props="common_field_required_error" />
      );
    }

    if (!uploadedFile) {
      temp.file = <GetLanguageString props="common_field_required_error" />;
    }
    // Validate recipient selection
    if (recipientType === "rafiq") {
      temp.selectedMember =
        selectedMember && selectedMember.value ? (
          ""
        ) : (
          <GetLanguageString props="common_field_required_error" />
        );
    } else if (recipientType === "rafiq_outside") {
      temp.selectedOutsideRafiq =
        selectedOutsideRafiq && memberId ? (
          ""
        ) : (
          <GetLanguageString props="common_field_required_error" />
        );
    } else if (recipientType === "registered") {
      temp.selectedHabib =
        selectedHabib && memberId ? (
          ""
        ) : (
          <GetLanguageString props="common_field_required_error" />
        );
    } else {
      // unregistered
      temp.unregisteredHabibName = unregisteredHabibName ? (
        ""
      ) : (
        <GetLanguageString props="common_field_required_error" />
      );
    }

    // Row validations
    let rowErrors = [];
    let hasRowErrors = false;
    infaqRows.forEach((row, index) => {
      let rowErr = { codeId: "", amount: "" };
      if (!row.codeId) {
        rowErr.codeId = <GetLanguageString props="common_field_required_error" />;
        hasRowErrors = true;
      }
      if (!row.amount || row.amount.toString().trim() === "") {
        rowErr.amount = <GetLanguageString props="common_field_required_error" />;
        hasRowErrors = true;
      } else {
        const parsedAmount = parseFloat(row.amount);
        if (isNaN(parsedAmount) || parsedAmount <= 0) {
          rowErr.amount = t("amount_must_be_greater_than_zero");
          hasRowErrors = true;
        }
      }
      rowErrors[index] = rowErr;
    });
    temp.rowErrors = hasRowErrors ? rowErrors : null;

    temp.memo = fundValues.memo && fundValues.memo.trim() !== "" ? "" : <GetLanguageString props="common_field_required_error" />;

    const currentTotal = infaqRows.reduce((sum, row) => sum + (parseFloat(row.amount) || 0), 0);
    if (currentTotal >= 5000) {
      temp.address = address && address.trim() !== "" ? "" : <GetLanguageString props="common_field_required_error" />;
    }

    setErrors((prev) => ({
      ...prev,
      ...temp,
    }));

    const isMainFieldsValid = Object.keys(temp).filter(k => k !== "rowErrors").every((k) => temp[k] === "");
    return isMainFieldsValid && !hasRowErrors;
  };
  const handleChangeMember = (record) => {
    setSelectedMember(record);
    setErrors((prev) => ({ ...prev, selectedMember: "" }));
  };

  const handleOnSelect = (item) => {
    var str = item?.name;
    let remove = str.split(" - ").pop();
    let requiredName = str.replace(" - " + remove, "   ");
    setSelectedHabib(requiredName + " - " + remove.replace("/", " "));
    setMemberId(item.id);
    setErrors({
      ...errors,
      selectedHabib: "",
    });
    setAhbabOptions([]);
  };

  const handleOnSelectOutsideRafiq = (item) => {
    var str = item?.name;
    let remove = str.split(" - ").pop();
    let requiredName = str.replace(" - " + remove, "   ");
    setSelectedOutsideRafiq(requiredName + " - " + remove.replace("/", " "));
    setMemberId(item.id);
    setErrors({
      ...errors,
      selectedOutsideRafiq: "",
    });
    setOutsideRafiqOptions([]);
  };

  const handleRecipientTypeChange = (e) => {
    const val = e.target.value;
    setRecipientType(val);
    // reset related fields
    setErrors({});
    setMemberId(0);
    if (val === "rafiq") {
      setSelectedOutsideRafiq("");
      setSelectedHabib(null);
      setUnregisteredHabibName("");
      if (members.length > 0) {
        setSelectedMember({
          value: members[0].id,
          label: members[0].name + " - " + members[0].regNo,
          name: members[0].name,
          regNo: members[0].regNo,
        });
      }
    } else if (val === "rafiq_outside") {
      setSelectedMember(null);
      setSelectedHabib(null);
      setUnregisteredHabibName("");
      setSelectedOutsideRafiq("");
    } else if (val === "registered") {
      setSelectedMember(null);
      setSelectedOutsideRafiq("");
      setUnregisteredHabibName("");
    } else {
      setSelectedMember(null);
      setSelectedHabib(null);
      setSelectedOutsideRafiq("");
      setUnregisteredHabibName("");
    }
  };

  const handleUnregisteredHabibName = (e) => {
    setUnregisteredHabibName(e.target.value);
    setErrors((prev) => ({ ...prev, unregisteredHabibName: "" }));
  };

  const handleReceiptNumber = (e) => {
    let { value } = e.target;
    value = value.replace(/\D/g, "");
    setFundValues((prev) => ({
      ...prev,
      receiptNumber: value,
    }));
    setErrors((prev) => ({ ...prev, receiptNumber: "" }));
  };

  const handleReceiptTypeChange = (e) => {
    const value = e.target.value;
    setReceiptType(value);
    if (value === "digital") {
      setFundValues((prev) => ({
        ...prev,
        receiptNumber: "",
      }));
      setErrors((prev) => ({ ...prev, receiptNumber: "" }));
    }
  };

  const handleInputChangeDate = (value) => {
    setSelectedDate(value);
    setErrors((prev) => ({ ...prev, date: "" }));
  };

  const handleMemoChange = (e) => {
    const val = e.target.value;
    setFundValues((prev) => ({
      ...prev,
      memo: val,
    }));
    if (val && val.trim() !== "") {
      setErrors((prev) => ({ ...prev, memo: "" }));
    }
  };


  const handleSubmit = async (addOther = false) => {
    if (!validate()) {
      // validation failed: don't proceed
      return;
    }
    setLoading(true);

    try {
      const formData = new FormData();
      const overrideCodeId = infaqRows[0]?.codeId || selectedInfaqHead?.value || fundValues.codeId || 0;
      // Determine memberId/person_id/codeId based on recipientType
      if (recipientType === "rafiq") {
        const rafiqName = selectedMember?.name || (selectedMember?.label ? (selectedMember.label.includes(" - ") ? selectedMember.label.split(" - ")[0].trim() : selectedMember.label.trim()) : "");
        formData.append("memberId", selectedMember?.value ?? "");
        formData.append("name", rafiqName);
        formData.append("codeId", overrideCodeId);
        formData.append("isRafiq", true);
      } else if (recipientType === "rafiq_outside") {
        const outMemberId = memberId || "";
        const outName =
          selectedOutsideRafiq && (selectedOutsideRafiq.name || selectedOutsideRafiq.label)
            ? (selectedOutsideRafiq.name || selectedOutsideRafiq.label)
            : typeof selectedOutsideRafiq === "string"
              ? selectedOutsideRafiq
              : "";
        formData.append("memberId", outMemberId);
        formData.append(
          "name",
          outName.includes(" - ")
            ? outName.split(" - ")[0].trim()
            : (outName.includes("-") ? outName.substring(0, outName.indexOf("-")).trim() : outName.trim()),
        );
        formData.append("codeId", overrideCodeId);
        formData.append("isRafiq", true);
        formData.append("isOutsideRafiq", true);
      } else if (recipientType === "registered") {
        const regMemberId =
          memberId || (selectedHabib && selectedHabib.value) || "";
        const regName =
          selectedHabib && (selectedHabib.name || selectedHabib.label)
            ? (selectedHabib.name || selectedHabib.label)
            : typeof selectedHabib === "string"
              ? selectedHabib
              : "";
        formData.append("memberId", regMemberId);
        formData.append(
          "name",
          regName.includes(" - ")
            ? regName.split(" - ")[0].trim()
            : (regName.includes("-") ? regName.substring(0, regName.indexOf("-")).trim() : regName.trim()),
        );
        formData.append("codeId", overrideCodeId);
        formData.append("isRafiq", false);
      } else {
        // unregistered
        formData.append("memberId", "");
        formData.append("name", unregisteredHabibName ? unregisteredHabibName.trim() : "");
        formData.append("codeId", overrideCodeId);
        formData.append("isRafiq", false);
      }
      formData.append("unitId", unitId);
      formData.append("date", convertToDateString(selectedDate));
      const monthToSend = selectedDate
        ? selectedDate.getMonth() + 1
        : fundValues.month;
      const yearToSend = selectedDate
        ? selectedDate.getFullYear()
        : fundValues.year;
      formData.append("month", monthToSend);
      formData.append("year", yearToSend);
      formData.append("receiptNumber", fundValues.receiptNumber);
      formData.append("generateDigitalReceipt", isUsraRole() ? true : receiptType === "digital");
      
      const totalAmount = infaqRows.reduce((sum, row) => sum + (parseFloat(row.amount) || 0), 0);
      formData.append("amount", totalAmount);
      formData.append("address", totalAmount >= 5000 ? address : "");
      formData.append("memo", fundValues.memo || "");
      formData.append("includeSubUnits", fundValues.includeSubUnit || false);

      // Append entries
      infaqRows.forEach((row, index) => {
        formData.append(`Entries[${index}].CodeId`, row.codeId.toString());
        formData.append(`Entries[${index}].Amount`, parseFloat(row.amount));
        formData.append(`Entries[${index}].LineMemo`, fundValues.memo || "");
      });

      // Append the file if it exists
      if (uploadedFile) {
        formData.append("file", uploadedFile);
      }
      const res = await ApiFund().addSingleInfaqAmanat(formData);
      if (res.data.statusCode === "200") {
        const transactionNo = res.data?.transactionNo;
        const shouldShowReceipt = transactionNo && Number(transactionNo) !== 0;

        const successTitle =
          (res.data?.message && t(res.data.message) !== res.data.message ? t(res.data.message) : "") ||
          (res.data?.Message && t(res.data.Message) !== res.data.Message ? t(res.data.Message) : "") ||
          t("funds_request_forwarded");

        swal({
          title: successTitle,
          className: GetSelectedLanguage() === "en" ? "" : "ur",
          icon: "success",
          buttons: shouldShowReceipt
            ? {
              OK: true,
              viewReceipt: {
                text: t("common_view_receipt") || "View Receipt",
                value: "viewReceipt",
              },
            }
            : "OK",
        }).then((value) => {
          if (value === "viewReceipt") {
            viewReceipt(transactionNo);
            return;
          }

          if (addOther) {
            // 🔁 reset only necessary fields
            setFundValues((prev) => ({
              ...prev,
              receiptNumber: "",
              amount: "",
              memo: "",
            }));
            const defaultCodeId = infaqHeads.length > 0 ? infaqHeads[0].value : "";
            setInfaqRows([{ codeId: defaultCodeId, amount: "" }]);
            setSelectedDate(new Date());
          } else {
            history.goBack();
          }
        });
      } else {
        swal({
          title: t(res.data.message) || t("funds_error_submit_request"),
          className: GetSelectedLanguage() === "en" ? "" : "ur",
          icon: "error",
          buttons: "OK",
        });
        setServerError(res.data.message);
      }
    } catch (err) {
      swal({
        title: err,
        className: GetSelectedLanguage() === "en" ? "" : "ur",
        icon: "error",
        buttons: "OK",
      });
      setServerError(err.response.data);
    } finally {
      setLoading(false);
    }
  };

  //#endregion functionHandler
  return (
    <>
      <ToastContainer
        autoClose={3000}
        bodyClassName={GetSelectedLanguage()}
        closeOnClick
        pauseOnHover={false}
        draggable
      />
      {serverError && <h4 className="text-danger">{serverError}</h4>}
      <div className="wrapper-custom wrapper wrapper-content animated fadeInRight">
        <div className="ibox ">
          <div className="ibox-title">
            <h5>{<GetLanguageString props="funds_add_fund" />}</h5>
            <Button
              className={GetCustomStyles().btn_style}
              color="white"
              size="xs"
              onClick={() => history.goBack()}
            >
              {" "}
              <IoArrowBackSharp
                color="#18A689"
                size={15}
                style={{ marginRight: 5, marginBottom: 1 }}
              />
              {<GetLanguageString props="courses_participants_back" />}{" "}
            </Button>
          </div>
          <div className="ibox-content">
            {!loading ? (
              <>
                <Row>
                  <SelectUnit
                    values={values}
                    setValues={setValues}
                    unitId={values.unit.value}
                    filterUnitTypes={["Usra", "UsraMuavin", "Munfarid"]}
                  />
                </Row>
                <hr />
                <Row>
                  <Col md={12}>
                    <FormGroup>
                      <div>
                        <FormGroup check inline>
                          <Label check style={{ marginRight: 24 }}>
                            <Input
                              type="radio"
                              name="recipientType"
                              value="rafiq"
                              checked={recipientType === "rafiq"}
                              onChange={handleRecipientTypeChange}
                            />{" "}
                            {<GetLanguageString props="rafiq" />}
                          </Label>
                        </FormGroup>
                        <FormGroup check inline>
                          <Label check style={{ marginRight: 24 }}>
                            <Input
                              type="radio"
                              name="recipientType"
                              value="rafiq_outside"
                              checked={recipientType === "rafiq_outside"}
                              onChange={handleRecipientTypeChange}
                            />{" "}
                            {<GetLanguageString props="rafiq_outside_nazm" />}
                          </Label>
                        </FormGroup>
                        <FormGroup check inline>
                          <Label check style={{ marginRight: 24 }}>
                            <Input
                              type="radio"
                              name="recipientType"
                              value="registered"
                              checked={recipientType === "registered"}
                              onChange={handleRecipientTypeChange}
                            />{" "}
                            {<GetLanguageString props="registered_habib" />}
                          </Label>
                        </FormGroup>
                        <FormGroup check inline>
                          <Label check style={{ marginRight: 24 }}>
                            <Input
                              type="radio"
                              name="recipientType"
                              value="unregistered"
                              checked={recipientType === "unregistered"}
                              onChange={handleRecipientTypeChange}
                            />{" "}
                            {<GetLanguageString props="unregistered_habib" />}
                          </Label>
                        </FormGroup>
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={fieldColSize}>
                    <FormGroup>
                      {/* Rafiq: existing member select */}
                      {recipientType === "rafiq" && (
                        <>
                          <Label className="col-form-label">
                            {<GetLanguageString props="funds_select_member" />}
                          </Label>
                          <Select
                            components={{
                              Option: customOption,
                              SingleValue: customSingleValue,
                            }}
                            value={selectedMember}
                            options={membersList}
                            className="basic-single ur"
                            classNamePrefix="select"
                            onChange={handleChangeMember}
                          />
                          {errors.selectedMember && (
                            <h4 className="text-error">
                              {
                                <GetLanguageString props="funds_member_error_message" />
                              }
                            </h4>
                          )}
                        </>
                      )}

                      {/* Rafiq Outside Nazm: searchable autocomplete */}
                      {recipientType === "rafiq_outside" && (
                        <>
                          <Label className="col-form-label">
                            {<GetLanguageString props="funds_select_member" />}
                          </Label>
                          <SearchAutoComplete
                            members={outsideRafiqOptions}
                            setMembers={setOutsideRafiqOptions}
                            setName={setSelectedOutsideRafiq}
                            name={selectedOutsideRafiq}
                            type={"rafiq"}
                            loading={loadingSearchOutside}
                            placeholder={t("common_search_by_name")}
                            handleOnSelect={handleOnSelectOutsideRafiq}
                            calledFrom="mudaris"
                          />
                          {errors.selectedOutsideRafiq && (
                            <h4 className="text-error">
                              {errors.selectedOutsideRafiq}
                            </h4>
                          )}
                        </>
                      )}

                      {/* Registered Habib */}
                      {recipientType === "registered" && (
                        <>
                          <Label className="col-form-label">
                            {<GetLanguageString props="member_search_habib" />}
                          </Label>
                          <SearchAutoComplete
                            members={ahbabOptions}
                            setMembers={setAhbabOptions}
                            setName={setSelectedHabib}
                            name={selectedHabib}
                            type={"habib"}
                            loading={loadingSearch}
                            placeholder={t("common_search_by_name")}
                            handleOnSelect={handleOnSelect}
                            calledFrom="mudaris"
                          />
                          {errors.selectedHabib && (
                            <h4 className="text-error">
                              {errors.selectedHabib}
                            </h4>
                          )}
                        </>
                      )}

                      {/* Unregistered Habib */}
                      {recipientType === "unregistered" && (
                        <>
                          <Label className="col-form-label">
                            {<GetLanguageString props="common_name" />}
                          </Label>
                          <Input
                            type="text"
                            value={unregisteredHabibName}
                            onChange={handleUnregisteredHabibName}
                          />
                          {errors.unregisteredHabibName && (
                            <h4 className="text-error">
                              {errors.unregisteredHabibName}
                            </h4>
                          )}
                        </>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md={fieldColSize}>
                    {" "}
                    <FormGroup>
                      {" "}
                      <Label className="col-form-label">
                        {" "}
                        {
                          <GetLanguageString props="funds_add_fund_date_paid" />
                        }{" "}
                      </Label>{" "}
                      <DatePicker
                         minDate={getMinMaxDates(selectedDate).minDate}
                         maxDate={getMinMaxDates(selectedDate).maxDate}
                        placeholderText="dd/mm/yyyy"
                        className="form-control no-drag"
                        dateFormat="dd/MM/yyyy"
                        selected={selectedDate}
                        onChange={handleInputChangeDate}
                      />
                      {errors.date && (
                        <h4 className="text-error">{errors.date}</h4>
                      )}{" "}
                    </FormGroup>{" "}
                  </Col>{" "}
{" "}
                  {!isUsraRole() && (
                    <Col md={fieldColSize}>
                      <FormGroup>
                        <div
                          className="col-form-label d-flex align-items-center"
                          style={{ gap: 16 }}
                        >
                          <Label check className="mb-0">
                            <Input
                              type="radio"
                              name="receiptTypeAmanatAccount"
                              value="physical"
                              checked={receiptType === "physical"}
                              onChange={handleReceiptTypeChange}
                            />{" "}
                            {<GetLanguageString props="funds_physical_receipt" />}
                          </Label>
                          <Label check className="mb-0">
                            <Input
                              type="radio"
                              name="receiptTypeAmanatAccount"
                              value="digital"
                              checked={receiptType === "digital"}
                              onChange={handleReceiptTypeChange}
                            />{" "}
                            {<GetLanguageString props="funds_digital_receipt" />}
                          </Label>
                        </div>
                        <Input
                          autoFocus
                          type="text"
                          className="no-drag"
                          value={fundValues.receiptNumber}
                          onChange={handleReceiptNumber}
                          disabled={receiptType === "digital"}
                        />
                        {errors.receiptNumber && (
                          <h4 className="text-error">{errors.receiptNumber}</h4>
                        )}
                      </FormGroup>
                    </Col>
                  )}{" "}
                  <Col md={fieldColSize}>
                    {" "}
                    <FormGroup>
                      {" "}
                      <Label className="col-form-label">
                        {" "}
                        <GetLanguageString props="transactions_memo" />{" "}
                      </Label>{" "}
                      <Input
                        type="text"
                        className="no-drag"
                        value={fundValues.memo}
                        onChange={handleMemoChange}
                        invalid={!!errors.memo}
                      />
                      {errors.memo && (
                        <h4 className="text-error">{errors.memo}</h4>
                      )}{" "}
                    </FormGroup>{" "}
                  </Col>{" "}
                  <Col md={fieldColSize}>
                    {" "}
                    <FormGroup>
                      {" "}
                      <Label className="col-form-label">
                        {" "}
                        <GetLanguageString props="deposit_slip" />{" "}
                      </Label>{" "}
                      <Input
                        type="file"
                        accept="image/*,application/pdf"
                        name="file"
                        invalid={!!errors.file}
                        onChange={handleFileChange}
                      />{" "}
                      {/* This will now show "Required" OR "File must be under 10MB" */}{" "}
                      {errors.file && (
                        <h4 className="text-error">{errors.file}</h4>
                      )}{" "}
                    </FormGroup>{" "}
                  </Col>{" "}
                </Row>

                {infaqRows.reduce((sum, row) => sum + (parseFloat(row.amount) || 0), 0) >= 5000 && (
                  <Row className="mt-2">
                    <Col md="4">
                      <FormGroup>
                        <Label className="col-form-label">
                          {<GetLanguageString props="member_address" />}
                        </Label>
                        <MemberAddressPreview
                          memberId={
                            recipientType === "rafiq"
                              ? selectedMember?.value
                              : (recipientType === "registered" || recipientType === "rafiq_outside")
                                ? memberId
                                : null
                          }
                          totalAmount={infaqRows.reduce((sum, row) => sum + (parseFloat(row.amount) || 0), 0)}
                        />
                        <Input
                          type="text"
                          className={`no-drag ${isUrdu(address) ? "ur" : ""}`}
                          value={address}
                          onChange={(e) => {
                            setAddress(e.target.value);
                            setErrors((prev) => ({ ...prev, address: "" }));
                          }}
                          placeholder="Enter address"
                        />
                        {errors.address && (
                          <h4 className="text-error">{errors.address}</h4>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>
                )}{" "}

                <div className="ibox mt-4">
                  <div className="ibox-title d-flex justify-content-between align-items-center">
                    <h5>
                      {
                        <GetLanguageString props="finance_infaq_entry_details" />
                      }
                    </h5>
                    <MdOutlineAddCircleOutline
                      size={25}
                      color="#3ba147"
                      onClick={addRow}
                      style={{ marginRight: 6, marginBottom: 1, cursor: "pointer" }}
                    />
                  </div>
                  <div className="ibox-content">
                    {infaqRows.map((row, index) => (
                      <Row key={index} className="mb-3 align-items-start">
                        <Col md>
                          <FormGroup>
                            <Label className="col-form-label">
                              {<GetLanguageString props="fund_account_head" />}
                            </Label>
                            <Select
                              options={infaqHeads}
                              value={infaqHeads.find(x => x.value === row.codeId) || null}
                              placeholder="Select infaq head"
                              onChange={(selected) => handleRowChange(index, "codeId", selected ? selected.value : "")}
                              className="basic-single no-drag"
                              classNamePrefix="select"
                            />
                            {errors.rowErrors?.[index]?.codeId && (
                              <h4 className="text-error">{errors.rowErrors[index].codeId}</h4>
                            )}
                          </FormGroup>
                        </Col>
                        <Col md>
                          <FormGroup>
                            <Label className="col-form-label">
                              {<GetLanguageString props="funds_add_fund_amount" />}
                            </Label>
                            <Input
                              type="text"
                              className="no-drag"
                              value={row.amount || ""}
                              onChange={(e) => {
                                let val = e.target.value.replace(/\D/g, "");
                                handleRowChange(index, "amount", val);
                              }}
                            />
                            {errors.rowErrors?.[index]?.amount && (
                              <h4 className="text-error">{errors.rowErrors[index].amount}</h4>
                            )}
                          </FormGroup>
                        </Col>
                        <Col
                          md="1"
                          className="text-center"
                        >
                          <Label className="col-form-label d-block">&nbsp;</Label>
                           {infaqRows.length === 1 ? (
                             <TbTrashOff
                               size={25}
                               color="#a72424"
                               style={{ opacity: 0.5 }}
                             />
                           ) : (
                             <TbTrash
                               size={25}
                               color="#bb0e0e"
                               style={{ cursor: "pointer" }}
                               onClick={() => removeRow(index)}
                             />
                           )}
                        </Col>
                      </Row>
                    ))}
                  </div>
                </div>

                <Row>
                  {" "}
                  <Col md="9"></Col>{" "}
                  <Col md="3" className="text-end">
                    {" "}
                    {CheckPermission("CanAddFunds") ? (
                      <>
                        {" "}
                        <Button color="white" onClick={() => history.goBack()}>
                          {" "}
                          {<GetLanguageString props="common_cancel" />}{" "}
                        </Button>{" "}
                        &nbsp;&nbsp;{" "}
                        <Button
                          color="primary"
                          onClick={() => handleSubmit(false)}
                        >
                          {" "}
                          {<GetLanguageString props="common_save" />}{" "}
                        </Button>{" "}
                        {/* <Button
                          color="success"
                          onClick={() => handleSubmit(true)}
                        >
                          {
                            <GetLanguageString props="funds_add_fund_and_add_other" />
                          }
                        </Button> */}
                      </>
                    ) : null}
                  </Col>
                </Row>
              </>
            ) : (
              LoadingSpinner()
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default withRouter(AddInfaqAmanatAccount);
